import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import nodeinstance from "../../nodeInstance";

const getDpendentMasterData = createAsyncThunk(
  "insurance-dependent/dependents",
  async (token, type) => {
   
    try {
      const response = await nodeinstance.get(
        `insurance-dependent/dependents`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log(response.data.data);
      return response.data.data;
    } catch (e) {
      throw new Error(e.message);
    }
  }
);

const dependetMasterSummary = createSlice({
  name: "dependentSummary",
  initialState: {
    data: null,
    error: "",
    status: false,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDpendentMasterData.fulfilled, (state, action) => {
        state.data = action.payload;
        state.isLoading = false;
        state.status = true;
      })
      .addCase(getDpendentMasterData.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getDpendentMasterData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export { getDpendentMasterData };
export default dependetMasterSummary.reducer;
